// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"e461dbc1","213":"3bcfde91","219":"202e3c6f","338":"04a79b96","445":"ea61c945","453":"2098d451","547":"3b2763ec","624":"1f58efcf","676":"c32c4019","732":"c6b05311","824":"12f3307e","868":"5ad228df"}[chunkId] + ".chunk.js";
};